import { StyledModal } from "../../../common/shared/modal.styled";
import styled from 'styled-components';
import bg from "../../../images/newDesign/coub5.svg";
import ellipseBg from "../../../images/newDesign/ellipse_shadow_illustration.svg";

export const RewardDetailsPopUp = styled(StyledModal)`
  &.header-with-bg {
    padding-inline-start: 17px;
    padding-inline-end: 17px;
    
    & .modal-dialog {
      top: 50%;
      transform: translateY(-50%);
      max-width: 660px;
      letter-spacing: 0.035em;

      & .modal-content {
        border: none;
        border-radius: 35px 35px 24px 24px;
      }
      
      & .modal-close {
        inset-block-start: 14px;
        inset-inline-end: 24px;
      }

      & .modal-icon {
        margin-bottom: 21px;
      }

      & .modal-button {
        margin: 40px auto 25px;
        font-family: var(--bllink-font-primary);
        font-size: 14px;
        font-weight: 700;
        letter-spacing: 0.07em;
      }

      & .modal-header {
        font-family: var(--bllink-font-primary);
        font-weight: 700;
        letter-spacing: 1px;
        padding-inline-start: 40px;
        padding-inline-end: 40px;
        z-index: 1;
        height: 53px;
      }
      
      & .modal-body {
        text-align: start;
        font-family: var(--bllink-font-primary);
        overflow: hidden;
        padding: 12px 22px;
        margin-inline-start: 16px;
        background: url(${bg}) no-repeat 56px -46px;
        background-size: 344px;
      }
      
      & .form{
        background: url(${ellipseBg}) no-repeat -30px 30px;
        background-size: 300px;
      }
      
      & .label {
        color: rgba(55, 54, 71, 0.7);
        font-weight: 700;
        font-size: 14px;
        line-height: 25px;
        padding-inline-start: 10px;
      }
      
      & .error {
        padding-inline-start: 10px;
      }
      
      & .form-control {
        height: 37px;
        width: 176px;
        margin-block-start: 8px;
      }
      
      & .section-title {
        width: 154px;
        height: 25px;
        margin-inline-start: 8px;

        font-style: normal;
        font-weight: 700;
        font-size: 20px;
        line-height: 25px;
        /* identical to box height, or 125% */
        color: rgba(55, 54, 71, 0.7);
      }
      
      & .lower-section {
        margin-top: 20px;
        padding-top: 12px;
        border-top: 1px solid rgba(216, 210, 255, 0.5);;
      }
      
      & .block-bg {
        position: absolute;
        inset-block-start: -50px;
        inset-inline-start: 35%;
        width: 50%;
        transform: translateX(-50%);
        z-index: 0;
      }
      
      & .upper-row {
        margin-block-start: 12px;
        letter-spacing: 0.02em;
      }
      
      & .lower-row {
        margin-block-start: 18px;
      }
    }
    
    & .button-explain {
      text-align: end;
    }
  }
`;
